import { render, staticRenderFns } from "./ProfileStatus.vue?vue&type=template&id=4b15fc10"
import script from "./ProfileStatus.vue?vue&type=script&lang=js"
export * from "./ProfileStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports